export default __webpack_public_path__ + "static/media/Mark-3-HUD-Process Info.a7d4b08e.jpg";